import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';
import './ObservationsTermsConditions.style.scss';

export const ObservationsTermsConditions = () => {
  return (
    <DynamicContent
      configPath={REMOTE_CONFIG_PATHS.TERMS_CONDITIONS.OBSERVATIONS}
      renderAsHtml={true}
    />
  );
};
